<template>
  <v-text-field
    :v-model="value"
    :value="value"
    v-bind="resetProps"
    v-on="$listeners"
    @input="$emit('update', $event)"
    :maxlength="maxlength"
    :tabindex="tabindex"
    :counter="counter"
    :class="{ 'counter-text': isCounter }"
  >
    <template #append>
      <slot name="append" :value="value" />
    </template>

    <template #prepend>
      <slot name="prepend" :value="value" />
    </template>
  </v-text-field>
</template>

<script>
import "./styles.scss";

export default {
  name: "Input",

  model: {
    prop: "value",
    event: "update",
  },

  props: {
    value: {
      default: "",
    },
    // max input character length
    maxlength: {
      type: Number,
      default: null,
    },

    tabindex: {
      type: [Number, String],
      default: 0,
    },

    isCounter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    resetProps() {
      return { ...this.$attrs };
    },

    counter() {
      return !_.isEmpty(this.value) && !!this.isCounter ? this.maxlength : false;
    },
  },
};
</script>
